module.exports = __webpack_public_path__ + "img/llc.0ef21d2a.jpg";